import { render, staticRenderFns } from "./block-text.vue?vue&type=template&id=75c7338a"
import script from "./block-text.vue?vue&type=script&lang=js"
export * from "./block-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports